// Fix duplicate ID issue for mobile form - run before custom element initializes
(function() {
  function fixMobileFormIds() {
    const mobileWrapper = document.querySelector('.main-product-mobile-section-wrapper');
    if (!mobileWrapper) return;
    
    const form = mobileWrapper.querySelector('recipient-form.recipient-form');
    if (!form) return;
    
    // Check if already fixed
    if (form.dataset.mobileFixed === 'true') return;
    
    // Get original section ID
    const originalSectionId = form.dataset.sectionId;
    if (!originalSectionId) return;
    
    // Create new unique section ID for mobile
    const mobileSectionId = originalSectionId + '-mobile';
    
    // Update data-section-id attribute
    form.dataset.sectionId = mobileSectionId;
    
    // Update all element IDs that contain the original section ID
    form.querySelectorAll('[id*="' + originalSectionId + '"]').forEach(el => {
      el.id = el.id.replace(originalSectionId, mobileSectionId);
    });
    
    // Update all 'for' attributes
    form.querySelectorAll('[for*="' + originalSectionId + '"]').forEach(el => {
      el.setAttribute('for', el.getAttribute('for').replace(originalSectionId, mobileSectionId));
    });
    
    // Update all aria-describedby attributes
    form.querySelectorAll('[aria-describedby*="' + originalSectionId + '"]').forEach(el => {
      el.setAttribute('aria-describedby', el.getAttribute('aria-describedby').replace(originalSectionId, mobileSectionId));
    });
    
    // Mark as fixed
    form.dataset.mobileFixed = 'true';
  }
  
  // Run immediately
  fixMobileFormIds();
  
  // Also run on DOMContentLoaded in case script loads before DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixMobileFormIds);
  }
})();

// Original recipient-form custom element
if (!customElements.get('recipient-form')) {
  customElements.define('recipient-form', class RecipientForm extends HTMLElement {
    constructor() {
      super();
      this.checkboxInput = this.querySelector(`#Recipient-checkbox-${ this.dataset.sectionId }`);
      if (!this.checkboxInput) return; // Guard if element not found
      
      this.checkboxInput.disabled = false;
      this.hiddenControlField = this.querySelector(`#Recipient-control-${ this.dataset.sectionId }`);
      if (this.hiddenControlField) this.hiddenControlField.disabled = true;
      this.emailInput = this.querySelector(`#Recipient-email-${ this.dataset.sectionId }`);
      this.nameInput = this.querySelector(`#Recipient-name-${ this.dataset.sectionId }`);
      this.messageInput = this.querySelector(`#Recipient-message-${ this.dataset.sectionId }`);
      this.sendonInput = this.querySelector(`#Recipient-send-on-${ this.dataset.sectionId }`);
      this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${ this.dataset.sectionId }`);
      if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset();

      this.currentProductVariantId = this.dataset.productVariantId;
      this.addEventListener('change', this.onChange.bind(this));
      this.onChange();
    }

    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;
    cartErrorUnsubscriber = undefined;

    connectedCallback() {
      // Guard if checkboxInput wasn't found
      if (!this.checkboxInput) return;
      
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
          this.resetRecipientForm();
        }
      });

      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event.data.sectionId === this.dataset.sectionId) {
          this.currentProductVariantId = event.data.variant.id.toString();
        }
      });

      this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
        if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
          this.displayErrorMessage(event.message, event.errors);
        }
      });
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }

      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }

      if (this.cartErrorUnsubscriber) {
        this.cartErrorUnsubscriber();
      }
    }

    onChange() {
      if (!this.checkboxInput) return;
      
      if (this.checkboxInput.checked) {
        this.enableInputFields();
      } else {
        this.clearInputFields();
        this.disableInputFields();
        this.clearErrorMessage();
      }
    }

    inputFields() {
      return [
        this.emailInput,
        this.nameInput,
        this.messageInput,
        this.sendonInput
      ].filter(Boolean); // Filter out null/undefined
    }

    disableableFields() {
      return [...this.inputFields(), this.offsetProperty].filter(Boolean);
    }

    clearInputFields() {
      this.inputFields().forEach((field) => field.value = '');
    }

    enableInputFields() {
      this.disableableFields().forEach((field) => field.disabled = false);
    }

    disableInputFields() {
      this.disableableFields().forEach((field) => field.disabled = true);
    }

    displayErrorMessage(title, body) {
      this.clearErrorMessage();
      if (typeof body === 'object') {
        return Object.entries(body).forEach(([key, value]) => {
          const errorMessageId = `RecipientForm-${ key }-error-${ this.dataset.sectionId }`
          const fieldSelector = `#Recipient-${ key }-${ this.dataset.sectionId }`;
          const message = `${value.join(', ')}`;
          const errorMessageElement = this.querySelector(`#${errorMessageId}`);
          const errorTextElement = errorMessageElement?.querySelector('.error-message')
          if (!errorTextElement) return;

          errorTextElement.innerText = `${message}.`;
          errorMessageElement.classList.remove('hidden');

          const inputElement = this[`${key}Input`];
          if (!inputElement) return;

          inputElement.setAttribute('aria-invalid', true);
          inputElement.setAttribute('aria-describedby', errorMessageId);
        });
      }
    }

    createErrorListItem(target, message) {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.setAttribute('href', target);
      a.innerText = message;
      li.appendChild(a);
      li.className = "error-message";
      return li;
    }

    clearErrorMessage() {
      this.querySelectorAll('.recipient-fields .form__message').forEach(field => {
        field.classList.add('hidden');
        const textField = field.querySelector('.error-message');
        if (textField) textField.innerText = '';
      });

      [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].filter(Boolean).forEach(inputElement => {
        inputElement.setAttribute('aria-invalid', false);
        inputElement.removeAttribute('aria-describedby');
      });
    }

    resetRecipientForm() {
      if (this.checkboxInput && this.checkboxInput.checked) {
        this.checkboxInput.checked = false;
        this.clearInputFields();
        this.clearErrorMessage();
      }
    }
  });
}